import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { findByTitulo, findByCategoria } from './api-comunicado-usuario';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { dateTimeFormat } from "../../../util/DateUtil";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { findAll } from "../ComunicadoCategoria/api-comunicado-categoria";
import TablePagination from '@mui/material/TablePagination';
import TablePaginationActions from '../../../shared/components/Table/Actions';
import { errorMessage } from '../../../util/ConfirmAlertUtil';


const useStyles = makeStyles(theme => ({
    table: {
        minWidth: '100%',
    },
    title: {
        marginTop: '10px'
    },
    novoRegistro: {
        marginBottom: '30px'
    },
    cursorLink: {
        cursor: 'pointer'
    },
    formControl: {
        // margin: theme.spacing(3),
    },
    closeIcon: {
        marginTop: '20px',
        cursor: 'pointer'
    }
}));


export default function ComunicadoUsuarioFindDialog({ openSearchComunicado, setOpenSearchComunicado, setComunicadoUsuario }) {
    const classes = useStyles();
    const [listCU, setListCU] = useState({
        content: [],
        totalElements: 0,
        number: 0,
        numberOfElements: 0
    });
    const [opcoesBusca, setOpcoesBusca] = useState({
        por: 'titulo',
        busca: ''
    });
    const [categorias, setCategorias] = useState([]);


    useEffect(() => {
        findAll().then((data) => {
            if (data.error) {
                errorMessage(data.message);
            } else {
                setCategorias(data);
            }
        })
    }, []);

    const closeSearchComunicado = () => {
        setOpenSearchComunicado(false);
    }

    const clickSubmit = (event) => {
        event.preventDefault();
        if (opcoesBusca.por === 'titulo') {
            findByTitulo(opcoesBusca.busca, 0).then((data) => {
                if (data.error) {
                    errorMessage(data.message);
                }
                else {
                    setListCU(data);
                }
            });
        } else if (opcoesBusca.por === 'categoria') {
            findByCategoria(opcoesBusca.busca, 0).then((data) => {
                if (data.error) {
                    errorMessage(data.message);
                }
                else {
                    setListCU(data);
                }
            });
        }
    }

    const handleCategoriaChange = (event) => {
        const categoria = categorias.find((categoria) => {
            return categoria.codigo === event.target.value
        });
        setOpcoesBusca({
            ...opcoesBusca,
            busca: categoria.codigo
        });
    }

    const handleBuscaChange = (event) => {
        setOpcoesBusca({
            ...opcoesBusca,
            [event.target.name]: event.target.value
        });

    }

    const handleSelected = (comunicado) => {
        setComunicadoUsuario(comunicado)
        closeSearchComunicado()
    }

    const handleClose = () => {
        closeSearchComunicado()
    };

    const handleChangePage = (event, newPage) => {
        if (opcoesBusca.por === 'titulo') {
            findByTitulo(opcoesBusca.busca, newPage).then((data) => {
                setListCU(data);
            }).catch((err) => console.log(err));
        } else if (opcoesBusca.por === 'categoria') {
            findByCategoria(opcoesBusca.busca, newPage).then((data) => {
                setListCU(data);
            }).catch((err) => console.log(err));
        }
    };

    return (
        <Dialog open={openSearchComunicado} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Procurar Comunicados</DialogTitle>
            <DialogContent>
                <form onSubmit={clickSubmit}>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <FormLabel component="legend">Buscar por:</FormLabel>
                        <RadioGroup aria-label="gender" name="por" value={opcoesBusca.por} onChange={handleBuscaChange}>
                            <FormControlLabel value="titulo" control={<Radio />} label="Título" />
                            <FormControlLabel value="categoria" control={<Radio />} label="Categoria" />
                        </RadioGroup>
                    </FormControl>
                    {opcoesBusca.por === 'categoria' ?
                        <FormControl fullWidth >
                            <InputLabel id="categoria-label">Categoria:</InputLabel>
                            <Select
                                labelId="categoria-label"
                                style={{ marginBottom: '20px' }}
                                id="categoria-select"
                                value={
                                    opcoesBusca.busca ?
                                        opcoesBusca.busca :
                                        ''
                                }
                                onChange={handleCategoriaChange}
                            >
                                {categorias.map((categoria, index) => (
                                    <MenuItem key={index} value={categoria.codigo}>
                                        {categoria.descricao}
                                    </MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                        :
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Busca"
                            name="busca"
                            autoFocus
                            onChange={handleBuscaChange}
                            value={opcoesBusca.busca || ''}
                        />}

                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.submit}>
                        Buscar
                    </Button>
                </form>
                <Table className={classes.table} size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Título</TableCell>
                            <TableCell>Categoria</TableCell>
                            <TableCell>Criado em</TableCell>
                            <TableCell>Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listCU.content.map((cu) => (
                            <TableRow key={cu.codigo}>
                                <TableCell>{cu.comunicado.titulo}</TableCell>
                                <TableCell>{cu.comunicado.categoria.descricao}</TableCell>
                                <TableCell>{dateTimeFormat(cu.createdAt)}</TableCell>
                                <TableCell>
                                    <Button
                                        onClick={() => handleSelected(cu)}
                                        variant="contained"
                                        color="secondary">
                                        Selecionar
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[]}
                    rowsPerPage={listCU.size ? listCU.size : 0}
                    component="div"
                    count={listCU.totalElements}
                    page={listCU.number}
                    onPageChange={handleChangePage}
                    labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : + " mais de " + to))}
                    slots={{
                        actions: TablePaginationActions
                    }}
                />


            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}